import { useState } from "react";
import { Button, Form, Modal } from "react-bootstrap";

const CreateGroupModal = ({
  isGroupModalOpen,
  setIsGroupModalOpen,
  userList,
  handleCreateGroup,
  createBy,
}) => {
  const [groupName, setGroupName] = useState("");
  const [description, setDescription] = useState("");
  const [groupImage, setGroupImage] = useState(null);
  const [selectedUsers, setSelectedUsers] = useState([]);

  const handleUserToggle = (user) => {
    const exists = selectedUsers.find((u) => u.userId === user.userId);
    if (exists) {
      setSelectedUsers(selectedUsers.filter((u) => u.userId !== user.userId));
    } else {
      setSelectedUsers([...selectedUsers, user]);
    }
  };

  const handleImageUpload = (e) => {

    console.log("Image upload triggered", e.target.files[0]);
    const file = e.target.files[0];
    if (file && file.type.startsWith("image/")) {
      console.log("Valid image file selected", file);
      setGroupImage(file);
    } else {
      alert("Only image files are allowed!");
    }
  };

  const onSubmit = () => {
    const createdBy = {
      userId: createBy?.uId,
      userName: createBy?.dName,
    };

    const allMembers = [
      {
        userId: createdBy.userId,
        firstName: createdBy.userName,
        lastName: "",
        role: "admin",
        addedAt: new Date().toISOString(),
      },
      ...selectedUsers, // selectedUsers is your existing member list (e.g., from multi-select UI)
    ];

  


    handleCreateGroup({
      groupName,
      description,
      groupImage,
      createdBy, // Replace with actual user ID
      members: allMembers,
    });
  };

  return (
    <Modal
      size="md"
      show={isGroupModalOpen}
      onHide={() => setIsGroupModalOpen(false)}
    >
      <Modal.Header closeButton>
        <Modal.Title>Create Group</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <Form>
          <Form.Group controlId="groupName">
            <Form.Label>Group Name</Form.Label>
            <Form.Control
              type="text"
              placeholder="Enter group name"
              value={groupName}
              onChange={(e) => setGroupName(e.target.value)}
            />
          </Form.Group>

          <Form.Group controlId="description" className="mt-3">
            <Form.Label>Description</Form.Label>
            <Form.Control
              as="textarea"
              rows={3}
              placeholder="Enter group description"
              value={description}
              onChange={(e) => setDescription(e.target.value)}
            />
          </Form.Group>

          <Form.Group controlId="groupImage" className="mt-3">
            <Form.Label>Upload Group Image</Form.Label>
            <Form.Control
              type="file"
              accept="image/*"
              onChange={handleImageUpload}
            />
          </Form.Group>

          <Form.Group controlId="friendSelect" className="mt-4">
            <Form.Label>Select Friends</Form.Label>
            <div
              style={{
                maxHeight: "200px",
                overflowY: "auto",
                border: "1px solid #ccc",
                padding: "10px",
              }}
            >
              {userList.map((user) => (
                <Form.Check
                  key={user.userId}
                  type="checkbox"
                  label={`${user.firstName} ${user.lastName}`}
                  onChange={() => handleUserToggle(user)}
                  checked={selectedUsers.some((u) => u.userId === user.userId)}
                />
              ))}
            </div>
          </Form.Group>
        </Form>
      </Modal.Body>

      <Modal.Footer>
        <Button variant="secondary" onClick={() => setIsGroupModalOpen(false)}>
          Cancel
        </Button>
        <Button variant="primary" onClick={onSubmit}>
          Create
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default CreateGroupModal;
